import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { useStateValue } from '../../functions/StateProvider';

const PersonalAreaModal = ({ show, onHide }) => {
  const [user, dispatch] = useStateValue();
  const [letters, setLetters] = useState([]);

  //   "http://localhost:3001/fetchLetters",

  useEffect(() => {
    axios
      .post('https://porfolioak.herokuapp.com/fetchLetters', {
        email: user.user != undefined ? user.user.email : '',
        headers: { 'Content-Type': 'application/json' },
      })
      .then((res) => setLetters(res.data))
      .catch((err) => '');
  }, [user]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Personal Area</Modal.Title>
        </Modal.Header>
        {letters.map((letter) => (
          <Modal.Body key={Math.random()}>
            <p>{letter.email}</p>
            <p>{letter.message}</p>
          </Modal.Body>
        ))}

        <Modal.Footer></Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default PersonalAreaModal;
